import { SHOW_DIALOG, HIDE_DIALOG } from "../actions";

const initialState = {
  isVisible: false,
  topPosition: 0,
  leftPosition: 0,
  message: "A short message",
  title: "A dialog",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SHOW_DIALOG:
      return {
        ...state,
        title: action.payload.title || "",
        message: action.payload.message,
        isVisible: true,
        topPosition: action.payload.topPosition,
        leftPosition: action.payload.leftPosition,
        origin: action.payload.origin,
      };

    case HIDE_DIALOG:
      return {
        ...state,
        isVisible: false,
      };

    default:
      return state;
  }
}
